<section class="block default-padding margin--bottom-l margin--top-l">
  <div class="default-max-width centered">
    <div class="layout-section-header">
      <div class="layout-section-header-main">
        <h3 class="headline-second">{{ data.title }}</h3>
      </div>
    </div>

    <div class="grid">
      <div *ngFor="let category of data.categories" class="grid__item one-third lap--one-half portable--one-whole">
        <div class="side-image-tile cover">
          <div class="side-image-tile-main">
            <h4 class="side-image-tile-title headline-third">
              {{ category.title }}
            </h4>

            <div class="default-font-sizes default-font-sizes--small">
              <p>
                {{ category.description }}
              </p>
            </div>
          </div>

          <a class="side-image-tile-footer cover-link" href="#" title="{{ category.title }}">
            <img
              *ngIf="category.image?.formats?.thumbnail"
              [src]="category.image.formats?.thumbnail?.url"
              [alt]="category.image.alternativeText"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
